import { IApiPlayerExtended, KOrBB, ResultTypes, AllResultTypes, CallTypes, HitTypes } from '@trackman/baseball-shared-components';
import { Play } from 'models/tagging/Play';
import { BaseRunners } from '../../models/baseRunners/BaseRunners';

const getSecondBaserunner = (play: Play): IApiPlayerExtended => {
  if (play.baseRunners.firstBase) {
    return play.baseRunners.firstBase;
  }

  return play.baseRunners.secondBase;
};
const getThirdBaserunner = (play: Play): IApiPlayerExtended => {
  if (play.baseRunners.firstBase && play.baseRunners.secondBase) {
    return play.baseRunners.secondBase;
  }

  return play.baseRunners.thirdBase;
};

const isMultipleBaserunners = (play: Play): boolean => {
  if (
    (play.baseRunners.firstBase && play.baseRunners.secondBase) ||
    (play.baseRunners.firstBase && play.baseRunners.thirdBase) ||
    (play.baseRunners.secondBase && play.baseRunners.thirdBase)
  ) {
    return true;
  }

  return false;
};

export const getBaseRunnersConsequences = (play: Play): BaseRunners => {
  const { batter } = play;

  if (play.korbb === KOrBB.Walk) {
    return {
      // TODO: CHECK ALL BATTERS
      firstBase: batter as unknown as IApiPlayerExtended,
      secondBase: getSecondBaserunner(play),
      thirdBase: getThirdBaserunner(play),
    };
  }

  if (play.tag.pitchCall !== CallTypes.InPlay) {
    if (play.tag.pitchCall === CallTypes.HitByPitch) {
      return {
        firstBase: batter as unknown as IApiPlayerExtended,
        secondBase: getSecondBaserunner(play),
        thirdBase: getThirdBaserunner(play),
      };
    }

    switch (play.tag.playResult) {
      case AllResultTypes.CaughtStealing: {
        if (isMultipleBaserunners(play)) {
          // Edge case: leave baserunners for tagger manual edit
          return play.baseRunners;
        }

        return {
          firstBase: null,
          secondBase: null,
          thirdBase: null,
        };
      }
      case AllResultTypes.StolenBase: {
        return {
          firstBase: null,
          secondBase: play.baseRunners.firstBase,
          thirdBase: play.baseRunners.secondBase,
        };
      }
    }

    return play.baseRunners;
  }

  switch (play.tag.playResult) {
    case ResultTypes.Single:
      return {
        firstBase: batter as unknown as IApiPlayerExtended,
        secondBase: play.baseRunners.firstBase,
        thirdBase: play.baseRunners.secondBase,
      };
    case ResultTypes.Double:
      return {
        firstBase: null,
        secondBase: batter as unknown as IApiPlayerExtended,
        thirdBase: play.baseRunners.firstBase,
      };
    case ResultTypes.Triple:
      return {
        firstBase: null,
        secondBase: null,
        thirdBase: batter as unknown as IApiPlayerExtended,
      };
    case ResultTypes.Homerun:
      return {
        firstBase: null,
        secondBase: null,
        thirdBase: null,
      };
    case ResultTypes.Error:
      return {
        firstBase: batter as unknown as IApiPlayerExtended, // Error, so allow tagger to set player manually
        secondBase: play.baseRunners.firstBase,
        thirdBase: play.baseRunners.secondBase,
      };
    case ResultTypes.FieldersChoice:
      return {
        firstBase: batter as unknown as IApiPlayerExtended,
        secondBase: null,
        thirdBase: null,
      };
    case ResultTypes.Out:
      if (play.tag.hitType === HitTypes.FlyBall || play.tag.hitType === HitTypes.Popup || play.tag.hitType === HitTypes.LineDrive) {
        return play.baseRunners;
      }

      if (play.tag.hitType === HitTypes.Bunt) {
        return {
          firstBase: batter as unknown as IApiPlayerExtended,
          secondBase: null,
          thirdBase: null,
        };
      }

      return {
        firstBase: null,
        secondBase: play.baseRunners.firstBase,
        thirdBase: play.baseRunners.secondBase,
      };
    case ResultTypes.Sacrifice:
    case AllResultTypes.StolenBase:
      return {
        firstBase: null,
        secondBase: play.baseRunners.firstBase,
        thirdBase: play.baseRunners.secondBase,
      };
    case ResultTypes.Undefined:
    default:
      return play.baseRunners; // do not change BR positions
  }
};
